

import React from "react";
//import Button from "../common/Button";
//import TestimonialCard from "../common/TestimonialCard";
import styles from "../css/TestimonialDriven.module.css";

function TestimonialDriven({ data }: any) {

  return (
    <section className={styles.testimonialDriven}>
      <h2 className={styles.headline}>{data.headline}</h2>
      <p className={styles.introText}>{data.introText}</p>
      <div className={styles.testimonials}>
        {/*
        {data.testimonials.map((testimonial: any, index: number) => (
          <TestimonialCard key={index} {...testimonial} />
        ))}
        */}
      </div>
      {data.caseStudies && (
        <div className={styles.caseStudies}>
          <h3>Case Studies</h3>
          {data.caseStudies.map((caseStudy: any, index: number) => (
            <div key={index} className={styles.caseStudy}>
              <h4>{caseStudy.title}</h4>
              <p><strong>Client:</strong> {caseStudy.client}</p>
              <p><strong>Challenge:</strong> {caseStudy.challenge}</p>
              <p><strong>Solution:</strong> {caseStudy.solution}</p>
              <p><strong>Results:</strong> {caseStudy.results}</p>
              {caseStudy.image && (
                <img 
                  src={caseStudy.image.src} 
                  alt={caseStudy.image.alt} 
                  className={styles.caseStudyImage}
                />
              )}
            </div>
          ))}
        </div>
      )}
      {data.awards && (
        <div className={styles.awards}>
          <h3>Awards & Recognition</h3>
          {data.awards.map((award: any, index: number) => (
            <div key={index} className={styles.award}>
              <img src={award.image.src} alt={award.image.alt} />
              <p>{award.title}</p>
              <p>{award.organization} - {award.year}</p>
            </div>
          ))}
        </div>
      )}
      <div className={styles.ctaContainer}>
        {/*<Button {...data.primaryCTA} />*/}
      </div>
    </section>
  );
};

export default TestimonialDriven;